var Usp = {};
Usp.init = function () {
  var $slider, $sliderDesktop, $sliderMobile, autoplayDesktop, autoplayMobile;
  $slider = $('.js-slider');
  if ($slider.length > 0) {
    $.each($slider, function () {
      $sliderDesktop = $(this).find('.js-usp-slider');
      $sliderMobile = $(this).find('.js-usp-slider-mobile');
      autoplayDesktop = $sliderDesktop ? $sliderDesktop.data('autoplay') : false;
      autoplayMobile = $sliderMobile ? $sliderMobile.data('autoplay') : false;
      $sliderDesktop.flickity({
        pageDots: true,
        contain: true,
        cellAlign: 'left',
        percentPosition: false,
        dragThreshold: 3,
        prevNextButtons: false,
        groupCells: true,
        autoPlay: autoplayDesktop,
        wrapAround: true,
        selectedAttraction: 0.01,
        friction: 0.15,
        freeScrollFriction: 0.02
      });
      $sliderMobile.flickity({
        pageDots: true,
        contain: true,
        cellAlign: 'left',
        percentPosition: false,
        dragThreshold: 3,
        prevNextButtons: false,
        groupCells: false,
        autoPlay: autoplayMobile,
        wrapAround: true,
        selectedAttraction: 0.01,
        friction: 0.15,
        freeScrollFriction: 0.02
      });
      $sliderDesktop.flickity('resize');
      $sliderMobile.flickity('resize');
    });
  }
};
Usp.init();
window.Usp = Usp;


// WEBPACK FOOTER //
// ./scripts/components/sliders/usp.js